import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import * as amplitude from '@amplitude/analytics-browser';
import { Page } from './ui';
import PhotoService from './PhotoService';
import { User } from '../user';
import RemoteGallery from '../files/RemoteGallery';
import React from 'react';
import RemoteDataContent from '../common/ui-component/layouts/RemoteDataContent';
import { Gallery, RemoteFile } from '../files';
import { FileObject } from 'react-mui-dropzone';
import { DateService } from '../common/date.service';

type Props = {
  user: User;
  inMemoryPhotos?: FileObject[];
  processedWithoutPhotosMode: boolean;
};

const PhotosSuccessfullyUploadedPage = (props: Props) => {
  const { t } = useTranslation('photosPage');
  const [getPhotos, rPhotos] = PhotoService.useGetPhotos();

  React.useEffect(() => {
    amplitude.track('photo_flow_complete');
    getPhotos(props.user.id);
  }, [getPhotos, props.user.id]);

  return (
    <Page>
      <Page.Title>{props.processedWithoutPhotosMode ? t('yourPhotos') : t('orderComplete')}</Page.Title>
      <Page.Text>
        {props.processedWithoutPhotosMode
          ? t('yourPhotosHaveBeenSuccessfullyUploaded')
          : t('yourDoctorWillNowReviewYourInformation')}
      </Page.Text>
      <Page.PhotosBox whiteBackground>
        <Page.UploadBox.Image>
          {!!props.inMemoryPhotos?.length ? (
            <>
              <Page.DateText>{DateTime.now().toFormat('LLL dd, yyyy')}</Page.DateText>
              <Gallery photos={props.inMemoryPhotos} />
            </>
          ) : (
            <RemoteDataContent value={rPhotos}>
              <RemoteDataContent.Success>
                {(photos: RemoteFile[] | null) =>
                  !photos ? (
                    <></>
                  ) : (
                    <>
                      <Page.DateText>{DateService.fromSQL(photos[0].date).toFormat('LLL dd, yyyy')}</Page.DateText>
                      <RemoteGallery photos={photos.filter((x) => x.type === 'other')} />
                    </>
                  )
                }
              </RemoteDataContent.Success>
            </RemoteDataContent>
          )}
        </Page.UploadBox.Image>
      </Page.PhotosBox>
    </Page>
  );
};

export default PhotosSuccessfullyUploadedPage;
